import { ApiService, encodeQueryData, NormalizeResponse, SERVICES } from '../../BaseService';

export const BonificationsService = {
    existsBonifications: (filters: any = {}) => {
        return NormalizeResponse(ApiService(SERVICES.WORK_PACKAGE_BUSINESS).get(`level-two/check-bonifications-exist?${encodeQueryData(filters)}`));
    }
};